<!-- Modal Template -->
<!-- <ng-template #template>
    <div class="modal-body">
        <div class="section full">
            <p class="title text-center" style="color:#2D847C !important;font-weight: 700;">{{ 'pTransfer' | translate}}</p>
            <div class="mt-1">
                <input type="text" class="dream-amt-input"
                    [(ngModel)]="currentInput" inputmode="numeric"
                    [ngModelOptions]="{standalone: true}" placeholder="{{ 'pMin' |translate }}" 
                    >
            </div>
        </div>
        <div class="section full">
            <div class="mt-1">
                <div class="row justify-content-center">
                    <button type="button" class="btn dream-cancel-btn mr-5" (click) ="closeModal()" style="width: 90px;">{{ 'cancel' | translate }}</button>
                    <button type="button" class="btn dream-cancel-btn" style = "width: 90px;">{{ 'forget-submit' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template> -->
<div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
</div>

<div class="modal-body">   
    <div class="container">
       <div class="row">{{ 'login_new_device' | translate }}</div>
       <div class="row d-flex justify-content-around pt-2">
        <button type="button" class="btn button-notRound" style="width: 125px;height: 40px;color: red;border: 1px solid #ddd; border-radius: 5px;" >{{ 'login_no' | translate}}</button>                    
        <button type="button" class="btn button-notRound" style="background-color: #017078; color: #fff;width: 125px;height: 40px; border-radius: 5px;">{{ 'login_yes' | translate}}</button>
      </div>
    </div>
</div>